export default __webpack_public_path__ + "static/definition-card-edit-light-mode-608163acd0f2d27f80ce7b73e9efa105.png";